import { Slide } from "@mui/material";
import React from "react";
import BackgroundOverlay from "../BackgroundOverlay";
import classes from "./Drawer.module.css";
const Drawer = (props) => {
  const {
    width = 300,
    position = "right",
    show = false,
    children,
    mountOnEnter = true,
    unmountOnExit = true,
    drawerStyles = {},
  } = props;
  return (
    <Slide
      mountOnEnter={mountOnEnter}
      unmountOnExit={unmountOnExit}
      direction={position === "right" ? "left" : "right"}
      in={show}
      style={{ width, ...drawerStyles }}
      className={`${classes["drawer-container"]} ${classes[position]}`}
    >
      <div className={classes["drawer-content"]}>
        {children}
        {show && <BackgroundOverlay />}
      </div>
    </Slide>
  );
};

export default Drawer;
